export const isAwaitingFiltration = (state) =>
  state.getIn(['filtrationStatus', 'awaitFiltration']);
export const hasResults = (state) =>
  state.getIn(['filtrationStatus', 'hasResults']);
export const hasSuggestResults = (state) =>
  state.getIn(['filtrationStatus', 'hasMore']);
